import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.524 6.25a.583.583 0 0 0-.583-.583h-3.5a.583.583 0 0 0-.583.583v3.5c0 .322.26.583.583.583h3.5c.322 0 .583-.26.583-.583zM9.358 9.167H7.024V6.833h2.334z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.024 2.75h2.334V1.583a.583.583 0 1 1 1.166 0V2.75h1.167c.967 0 1.75.784 1.75 1.75v1.167h1.167a.583.583 0 1 1 0 1.166H13.44v1.75h1.167a.583.583 0 1 1 0 1.167H13.44v1.75a1.75 1.75 0 0 1-1.75 1.75h-1.167v1.167a.583.583 0 1 1-1.166 0V13.25H7.024v1.167a.583.583 0 1 1-1.166 0V13.25H4.691a1.75 1.75 0 0 1-1.75-1.75V9.75H1.774a.583.583 0 1 1 0-1.166h1.167v-1.75H1.774a.583.583 0 1 1 0-1.167h1.167V4.5c0-.966.784-1.75 1.75-1.75h1.167V1.583a.583.583 0 1 1 1.166 0zm-.586 1.166H4.69a.584.584 0 0 0-.584.584v7c0 .322.262.583.584.583h7a.583.583 0 0 0 .583-.583v-7a.584.584 0 0 0-.583-.584H6.438",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })